import React, { useEffect } from "react";
import "./AboutUs.css";

import AOS from "aos";
import "aos/dist/aos.css";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div className="container-fluid py-5 about-container ">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div
            className="col-12 col-md-6 text-center text-md-left mb-4 mb-md-0 order-md-1 order-2"
            // data-aos="fade-up"
          >
            <img
              src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F85117d54770d4ca286a946159b43cf70`}
              alt="About Us"
              className="img-fluid"
              style={{ width: "100%" }}
            />
          </div>

          <div
            className="col-12 col-md-6 order-md-2 order-1"
            // data-aos="fade-down"
          >
            <h1 className="mb-3 about-title">About us</h1>
            <h4 className="mb-3 about-subTitle">
              Proven Leadership In Real Estate
            </h4>
            <p className="text-left about-desc">
              Skyline Infra, under the leadership of Mr. Subrahmanyam, is
              testament to his expertise and dedication in the real estate
              sector. With the solid foundation in the industry, Mr.
              Subrahmanyam has established Skyline Infra which is poised to gain
              a prestigious name in the realm of a real estate development.
              Every project is done to the greatest safety and standards, on
              schedule, and under budget thanks to the expertise of our staff.
              With an emphasis on cutting-edge technology and the
              sustainability, we provide top-notch infrastructure that satisfies
              the modern requirements
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
